module.exports = __webpack_public_path__ + "static/q5-353d7732a60deff3e5c101321d35c33f.png";